import logoImg from '../assets/logo.png';
import React from 'react';
import './WelcomeScreen.css';

export default function WelcomeScreen({ onStart }) {
  return (
    <div className="welcome-page">

      <div className="welcome-warning">
        <i className="ti ti-shield-lock" aria-hidden="true" />
        <div>
          <strong>Confidential — Internal Use Only</strong>
          <p>
            This system contains SWISO TECH proprietary delivery processes and standards.
            Access is restricted to authorised employees only. Unauthorised access,
            distribution, or reproduction of this content is strictly prohibited
            and may result in disciplinary action.
          </p>
        </div>
      </div>

      <div className="welcome-card">
        <div className="welcome-logo-wrap">
          <img src={logoImg} alt="SWISO dev" className="welcome-logo-img" />
        </div>

        <div className="welcome-divider" />

        <h1 className="welcome-title">Employee Process Guide</h1>
        <p className="welcome-subtitle">
          Your interactive SDLC handbook — role-based checklists, process rules,
          a smart wizard, and a guided assistant for every phase of project delivery.
        </p>

        <div className="welcome-features">
          {[
            { icon:'ti-map-2',         title:'Smart wizard',          sub:"Tell us where you are — we guide what's next" },
            { icon:'ti-checklist',     title:'Role-based checklists', sub:'Only the sections and rules relevant to your role' },
            { icon:'ti-message-2',     title:'Guided chat assistant', sub:'Ask anything about rules, steps, or processes' },
            { icon:'ti-device-floppy', title:'Progress saved locally',sub:'Your checklist progress persists in your browser' },
          ].map(({ icon, title, sub }) => (
            <div key={title} className="welcome-feature">
              <div className="welcome-feature-icon">
                <i className={`ti ${icon}`} aria-hidden="true" />
              </div>
              <div>
                <div className="welcome-feature-title">{title}</div>
                <div className="welcome-feature-sub">{sub}</div>
              </div>
            </div>
          ))}
        </div>

        <button className="welcome-btn" onClick={onStart}>
          <i className="ti ti-arrow-right" aria-hidden="true" />
          Get started — select your role
        </button>

        <div className="welcome-powered">
          <span>Powered by</span>
          <img src={logoImg} alt="SWISO dev" className="welcome-powered-logo" />
          <span>Technology L.L.C.</span>
        </div>
      </div>
    </div>
  );
}
